import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Cookies from "universal-cookie";
import { NavLink } from 'react-router-dom';

// Material-UI Components
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';

// Import Lucide React Icons
import {
  CheckCheck,
  Package,
  Store,
  DollarSign,
  TrendingDown,
  ShoppingCart,
  PackageX,
  FileText,
  Printer,
  Archive,
  Truck,
  RotateCcw,
  Search,
  ListX,
  Settings,
  Wrench,
  Phone,
  PhoneOff,
  Megaphone,
  BarChart3,
  ChevronDown,
  ChevronLeft,
  LogOut,
  Users,
  UserCheck,
  UserCog,
  Eye,
  Bell,
  Clock,
  AlertTriangle,
  ClipboardList,
  Calendar,
  CheckCircle,
  TrendingUp,
  Menu,
  X,
  Sun,
  Moon,
  ChevronsLeft,
  ChevronsRight
} from 'lucide-react';

// Dashboard Components
import Replacement from '../dash/replacement';
import ShippingcompaniesList from '../dash/shippingCompaniesList';
import Safe from '../dash/safe';
import UncheckedBill from '../dash/uncheckedBill';
import Unavailable from '../dash/unavailable';
import UsersList from '../dash/userList';
import Calsslog from '../dash/callsLogs';
import SanaDevs from '../dash/SanaDevs';
import RejctedList from '../dash/rejectedLIst';
import LogsCan from '../dash/LogsCan';
import Login from '../common/login';
import Cate2 from '../dash/cate2';
import FromOrders from '../dash/fromOrders';
import Wattingselles from '../dash/wattingReports.';
import Miss from '../dash/miss';
import Apanding_order from '../dash/apanding_order';
import Print_list from '../dash/print_list';
import CancelledOrders from '../dash/cancelledOrders';
import DoneTable from '../dash/doneTable';
import Sheet from '../dash/sheet';
import Check from '../dash/check';
import Print from '../dash/Print';
import M3alk from '../dash/m3alk';
import SuppliersList from '../dash/SuppliersList';
import PurchaseLists from '../dash/PurchaseLists';
import PurchaseListDetail from '../dash/PurchaseListDetail';
// ⚠️ PurchaseListDetail.jsx كُتب فوقها نسخة من صفحة رواجع الاستبدالات،
// فصار /purchaseList يفتح الاستبدالات. الملف لم يُمسّ — التوجيه تغيّر
// إلى إعادة بناء الصفحة على عقد GET /purchase/list/:id.
import PurchaseListView from '../dash/PurchaseListView';
import SpareParts from '../dash/SpareParts';
import StockTransfer from '../dash/StockTransfer';
import DeviceLogs from '../dash/DeviceLogs';
import DeviceReports from '../dash/DeviceReports';
import FinanceReport from '../dash/FinanceReport';
import ExchangeReturns from '../dash/ExchangeReturns';
import DoneReports from '../dash/doneOrdersReports';
import CalledOrders from '../dash/calledOrders';
import FromOrdersWatting from '../dash/fromOrdersWaittng';
import Sells from '../dash/sells_reports';
import DelveryReports from '../dash/delveryReports';
import SanaToInv from '../dash/sanaToInv';
import Expenses from '../dash/expenses';
import Order2 from '../dash/Order2';
import Setting from '../dash/setting';
import DoneOrder from '../dash/DoneOrder';
import RejectOrder from '../dash/RejectOrder';
import SearchPage from '../dash/Search';
import Logs from '../dash/ordersLogs';
import AdsReprots from '../dash/ads_reports';
import BillsList from '../dash/billsList';
import SanaLists from '../dash/sanaToIist';
import NewNotifications from '../dash/newNotifications';
import noResponse from '../dash/noResponse';
import Postponed from '../dash/postponed';
import OrdersStatusReports from '../dash/OrdersStatusReports';
import OrdersReports from '../dash/OrdersReports';
import SanaReport from '../dash/sanaReports.jsx';

import host from '../../assets/js/Host';

const cookies = new Cookies();

// عرض الشريط: كامل، ومطويّ إلى شريط أيقونات على الشاشات الضيقة أفقياً
const RAIL_FULL = 292;
const RAIL_MINI = 82;

const role = Number(localStorage.getItem('role'));
const userName = localStorage.getItem('name');

const THEME_KEY = 'dash_sidebar_theme';
const COLLAPSE_KEY = 'dash_sidebar_collapsed';
const FONT_KEY = 'dash_font_size';   // s | m | l

const readPref = (k, d) => {
  try { const v = localStorage.getItem(k); return v === null ? d : v; }
  catch (e) { return d; }
};
const writePref = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { } };

// تحميل الخط بوسم في <head> بدل @import داخل <style> في الجسم:
// الأخير هشّ وقد يتجاهله المتصفح، فيسقط النص على خط بديل يبدو باهتاً.
// وإن تعذّر التحميل فالبديل Segoe UI/Tahoma وكلاهما واضح للعربية.
const ensureFont = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById('dash-font')) return;
  const l = document.createElement('link');
  l.id = 'dash-font';
  l.rel = 'stylesheet';
  l.href = 'https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800&display=swap';
  document.head.appendChild(l);
};

// أنماط MUI للهيكل فقط — المظهر كله في ورقة الأنماط أدناه.
// العرض دالّة في الخصائص كي يتحرّك المحتوى مع طيّ الشريط.
const useStyles = makeStyles((theme) => ({
  root: { display: 'flex' },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: props => props.w,
      flexShrink: 0,
      transition: 'width .22s ease',
    },
  },
  appBar: {
    [theme.breakpoints.up('md')]: {
      width: props => `calc(100% - ${props.w}px)`,
      marginRight: props => props.w,
      transition: 'width .22s ease, margin .22s ease',
    },
    backgroundColor: 'rgba(255,255,255,.86)',
    backdropFilter: 'saturate(180%) blur(12px)',
    color: '#0b1220',
    boxShadow: 'none',
    borderBottom: '1px solid #e3eaf2',
  },
  menuButton: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('md')]: { display: 'none' },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: props => props.w,
    border: 'none',
    right: 0,
    left: 'auto',
    overflow: 'hidden',
    transition: 'width .22s ease',
  },
  drawerPaperMobile: { width: RAIL_FULL, border: 'none', right: 0, left: 'auto' },
  content: {
    flexGrow: 1,
    minWidth: 0,          // بلا هذا يمنع محتوى عريض الفليكس من الانكماش
    backgroundColor: '#eef2f7',
    minHeight: '100vh',
    width: '100%',
    padding: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: { padding: theme.spacing(2.5) },
  },
}));

const sidebarStyles = `
/* ============ الرموز ============
   نغمة فاتحة صريحة تجاور محتوى فاتحاً.
   الأقسام تُميَّز بعمود رفيع ملوّن لا بمربّعات أيقونات — العمود يقول
   شيئاً صحيحاً (هذه العناصر تتبع هذا القسم) بدل أن يزخرف.

   ⚠️ التباين: الرمادي الفاتح على أبيض كان ٢٫٨:١ وهو دون الحد المقروء
   (٤٫٥:١). كل الرماديات هنا مرفوعة فوق الحد. */
.sb {
  --bg:#ffffff; --bg2:#f5f8fc; --line:#dfe7f0; --line-soft:#eaf0f7;
  --ink:#0a1018; --mut:#3f5063; --faint:#5f7288;
  --acc:#1749c9; --acc-soft:#eaf1ff; --acc-line:#bcd3fb;
  --danger:#a81717; --danger-soft:#fef2f2;

  /* سلّم الخطوط — ثلاثة مستويات يختارها المستخدم من الترويسة */
  --f1:12.5px; --f2:14px; --f3:15.5px; --f4:16.5px; --f5:17.5px; --f6:19.5px;
  --pad:12px;

  height:100%; display:flex; flex-direction:column; direction:rtl;
  font-family:'Tajawal','Dubai','Segoe UI','Noto Kufi Arabic',Tahoma,Arial,sans-serif;
  background:var(--bg); color:var(--ink);
  border-left:1px solid var(--line);
  text-align:right;
  -webkit-font-smoothing:antialiased; text-rendering:optimizeLegibility;
}
.sb.fs-s{ --f1:11.5px; --f2:13px; --f3:14px; --f4:15px; --f5:16px; --f6:18px; --pad:10px; }
.sb.fs-l{ --f1:14px; --f2:15.5px; --f3:17.5px; --f4:18.5px; --f5:20px; --f6:22px; --pad:14px; }

.sb.dark {
  --bg:#11151d; --bg2:#182029; --line:#2a3442; --line-soft:#212a36;
  --ink:#f4f7fb; --mut:#b8c6d6; --faint:#94a6ba;
  --acc:#6ea0ff; --acc-soft:#17253d; --acc-line:#2f4570;
  --danger:#ff8b8b; --danger-soft:#2a1618;
  border-left-color:#2a3442;
}

/* ============ الترويسة ============ */
.sb-head{ padding:14px 16px; border-bottom:1px solid var(--line); flex-shrink:0; }
.sb-tools{ display:flex; gap:8px; flex-wrap:wrap; }
.sb-icon{
  flex:1 1 auto; min-height:40px; padding:0 10px;
  border:1px solid var(--line); border-radius:11px; background:var(--bg2);
  color:var(--mut); cursor:pointer; display:flex; align-items:center; justify-content:center;
  font:inherit; font-size:var(--f2); font-weight:700; gap:7px; transition:background .15s,color .15s;
}
.sb-icon:hover{ background:var(--acc-soft); color:var(--acc); border-color:var(--acc-line); }
.sb-icon:focus-visible{ outline:2px solid var(--acc); outline-offset:2px; }

/* مقياس الخط — الشكوى الأشيع، فليكن بيد المستخدم لا بتقديرنا */
.sb-fs{ display:flex; gap:6px; align-items:center; margin-top:8px; }
.sb-fs-l{ font-size:var(--f1); text-align:right; color:var(--faint); font-weight:700; margin-inline-end:2px; }
.sb-fs button{
  width:36px; height:34px; border:1px solid var(--line); border-radius:9px; background:var(--bg2);
  color:var(--mut); cursor:pointer; font:inherit; font-weight:800; line-height:1;
  display:flex; align-items:center; justify-content:center;
}
.sb-fs button:hover{ background:var(--acc-soft); color:var(--acc); border-color:var(--acc-line); }
.sb-fs button:focus-visible{ outline:2px solid var(--acc); outline-offset:2px; }
.sb-fs button.on{ background:var(--acc); color:#fff; border-color:var(--acc); }
.sb-fs button.s{ font-size:12px; }
.sb-fs button.m{ font-size:15px; }
.sb-fs button.g{ font-size:18px; }

/* ============ البحث في القائمة ============ */
.sb-search{ position:relative; margin-top:12px; }
.sb-search input{
  width:100%; text-align:right; box-sizing:border-box; font:inherit; font-size:var(--f3); font-weight:600;
  padding:12px 14px 12px 42px; border:1px solid var(--line); border-radius:12px;
  background:var(--bg2); color:var(--ink); outline:none; transition:border-color .15s,box-shadow .15s;
}
.sb-search input::placeholder{ color:var(--faint); font-weight:500; }
.sb-search input:focus{ border-color:var(--acc); box-shadow:0 0 0 3px rgba(23,73,201,.16); background:var(--bg); }
.sb-search svg{ position:absolute; top:50%; left:13px; transform:translateY(-50%); color:var(--faint); pointer-events:none; }

/* ============ بطاقة المستخدم ============ */
.sb-user{ display:flex; align-items:center; gap:12px; padding:18px 16px 16px; border-bottom:1px solid var(--line); flex-shrink:0; }
.sb-ava{
  width:42px; height:42px; flex:0 0 42px; border-radius:13px; display:flex; align-items:center; justify-content:center;
  background:var(--acc-soft); color:var(--acc); font-weight:800; font-size:var(--f5); border:1px solid var(--acc-line);
}
.sb-user-t{ min-width:0; }
.sb-user-t h4{ margin:0; text-align:right; font-size:var(--f4); font-weight:700; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; line-height:1.35; }
.sb-user-t div{ font-size:var(--f2); color:var(--faint); display:flex; align-items:center; gap:6px; margin-top:2px; font-weight:600; }
.sb-dot{ width:8px; height:8px; border-radius:50%; background:#16a34a; box-shadow:0 0 0 3px rgba(22,163,74,.2); }

/* ============ التنقّل ============ */
.sb-nav{ flex:1; overflow-y:auto; overflow-x:hidden; padding:10px 10px 18px; }
.sb-nav::-webkit-scrollbar{ width:8px; }
.sb-nav::-webkit-scrollbar-thumb{ background:var(--line); border-radius:4px; }
.sb-nav::-webkit-scrollbar-thumb:hover{ background:var(--faint); }

.sb-sec{ margin-bottom:4px; }
.sb-sec-btn{
  width:100%; display:flex; align-items:center; gap:11px; padding:var(--pad) 11px;
  background:none; border:0; border-radius:11px; cursor:pointer; font:inherit;
  color:var(--mut); transition:background .14s,color .14s;
}
.sb-sec-btn:hover{ background:var(--bg2); color:var(--ink); }
.sb-sec-btn:focus-visible{ outline:2px solid var(--acc); outline-offset:-2px; }
.sb-sec-btn.has-active{ color:var(--ink); }
.sb-sec-ico{ width:10px; height:10px; border-radius:3px; flex:0 0 10px; }
.sb-sec-t{ flex:1; text-align:right; font-size:var(--f3); font-weight:800; letter-spacing:0; }
.sb-sec-n{ font-size:var(--f1); text-align:center; font-weight:800; color:var(--faint); font-variant-numeric:tabular-nums; }
.sb-caret{ transition:transform .2s ease; color:var(--faint); flex-shrink:0; }
.sb-caret.open{ transform:rotate(-90deg); }

/* العمود الفقري: خيط رأسي بلون القسم تتعلّق به عناصره */
.sb-items{ display:none; padding:2px 0 7px; margin-inline-start:16px; border-inline-start:2px solid var(--line-soft); }
.sb-items.open{ display:block; }
.sb-sec.tinted .sb-items{ border-inline-start-color:var(--sec); }

.sb-link{
  position:relative; display:flex; align-items:center; gap:11px;
  padding:var(--pad) 12px; margin:3px 0; margin-inline-start:9px;
  border-radius:11px; text-decoration:none; color:var(--mut);
  font-size:var(--f4); font-weight:600; line-height:1.4;
  transition:background .14s,color .14s;
}
.sb-link:hover{ background:var(--bg2); color:var(--ink); }
.sb-link:focus-visible{ outline:2px solid var(--acc); outline-offset:-2px; }
.sb-link.active{ background:var(--acc-soft); color:var(--acc); font-weight:800; }
.sb-link.active::before{
  content:''; position:absolute; inset-inline-start:-18px; top:50%; transform:translateY(-50%);
  width:10px; height:10px; border-radius:50%; background:var(--acc);
  box-shadow:0 0 0 3px var(--bg);
}
.sb-link-ico{ flex-shrink:0; opacity:.9; margin-inline-start:auto; }
.sb-link.active .sb-link-ico{ opacity:1; }
.sb-link-t{ flex:0 1 auto; min-width:0; text-align:right; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.sb-badge{
  min-width:23px; height:23px; padding:0 7px; border-radius:12px; background:var(--danger);
  color:#fff; font-size:var(--f1); font-weight:800; display:flex; align-items:center; justify-content:center;
  font-variant-numeric:tabular-nums;
}
.sb-none{ padding:30px 14px; text-align:center; color:var(--faint); font-size:var(--f3); font-weight:600; }

/* ============ التذييل ============ */
.sb-foot{ padding:12px; border-top:1px solid var(--line); flex-shrink:0; }
.sb-out{
  width:100%; display:flex; align-items:center; justify-content:center; gap:10px;
  padding:13px; border-radius:12px; border:1px solid var(--line);
  background:var(--bg2); color:var(--danger); font:inherit; font-size:var(--f4); font-weight:700; cursor:pointer;
  transition:background .15s,border-color .15s;
}
.sb-out:hover{ background:var(--danger-soft); border-color:var(--danger); }
.sb-out:focus-visible{ outline:2px solid var(--danger); outline-offset:2px; }

/* الأزرار موسّطة رغم محاذاة الجذر يميناً */
.sb-icon,.sb-out,.sb-fs button,.sb-none{ text-align:center; }

/* ============ الوضع المطويّ (شريط أيقونات) ============ */
.sb.mini .sb-user-t,
.sb.mini .sb-search,
.sb.mini .sb-fs,
.sb.mini .sb-sec-t,
.sb.mini .sb-sec-n,
.sb.mini .sb-caret,
.sb.mini .sb-link-t,
.sb.mini .sb-icon span{ display:none; }
.sb.mini .sb-head,
.sb.mini .sb-user{ padding-inline:14px; justify-content:center; }
.sb.mini .sb-tools{ flex-direction:column; }
.sb.mini .sb-nav{ padding:10px 8px; }
.sb.mini .sb-items{ display:block; margin:0; border:0; }
.sb.mini .sb-sec-btn{ display:none; }
.sb.mini .sb-sec{ margin-bottom:9px; padding-bottom:9px; border-bottom:1px solid var(--line-soft); }
.sb.mini .sb-sec:last-child{ border-bottom:0; }
.sb.mini .sb-link{ justify-content:center; margin:4px 0; padding:13px 0; }
.sb.mini .sb-link.active::before{ display:none; }
.sb.mini .sb-badge{ position:absolute; top:2px; inset-inline-end:5px; min-width:19px; height:19px; }

/* ============ منطقة المحتوى — تسري على كل الصفحات ============ */
.dash-card{
  background:#fff; border:1px solid #dfe7f0; border-radius:16px;
  padding:18px; box-shadow:0 1px 2px rgba(15,23,42,.04);
  min-height:calc(100vh - 132px);
  font-family:'Tajawal','Dubai','Segoe UI',Tahoma,Arial,sans-serif;
  font-size:16px; color:#0a1018;
  /* جداول الصفحات القديمة أعرض من الشاشة على الموبايل: تمرير داخل
     البطاقة أفضل من تمرير الصفحة كلها وانكسار التخطيط. */
  overflow-x:auto;
}
.dash-card.fs-s{ font-size:15px; }
.dash-card.fs-l{ font-size:18px; }
@media (max-width:900px){
  .dash-card{ padding:12px; border-radius:14px; min-height:calc(100vh - 116px); }
}
@media (max-width:600px){
  .dash-card{ padding:10px; border-radius:12px; }
}
.dash-card .MuiPaper-root{ box-shadow:none !important; }

/* صفحة تفتح غلافها الخاص (مثل تقارير الأجهزة) لا تحتاج بطاقة حولها */
.dash-card > .dr-root{ margin:-18px; }
@media (max-width:900px){ .dash-card > .dr-root{ margin:-12px; } }

.sb-title{ font-family:'Tajawal',"Segoe UI",Tahoma,sans-serif; font-weight:700; font-size:18px; color:#0a1018; }
.sb-who{ font-size:15px; color:#3f5063; font-weight:600; font-family:'Tajawal',"Segoe UI",Tahoma,sans-serif; }
@media (max-width:600px){ .sb-title{ font-size:16px; } .sb-who{ display:none; } }

@media (prefers-reduced-motion:reduce){ .sb *,.sb{ transition:none !important; } }
`;

// Permission helper
const hasPermission = (userRole, requiredPermission) => {
  const permissions = {
    [-1]: ['all'],
    [0]: ['products', 'monitoring', 'orders', 'maintenance', 'reports_basic'],
    [1]: ['products', 'finance_limited', 'employees', 'monitoring', 'orders', 'maintenance', 'reports_basic'],
    [2]: ['products', 'reports_promotion']
  };
  const userPermissions = permissions[userRole] || [];
  if (userPermissions.includes('all')) return true;
  return userPermissions.includes(requiredPermission);
};

// Navigation Data
const getNavigationSections = (role, billsCount) => [
  {
    id: 'products',
    title: 'المخزن والأجهزة',
    icon: Package,
    color: 'blue',
    // شرط القسم = مجموع شروط عناصره. لو ضاق عن أحدها اختفى عنصر مسموح
    // بلا سبب ظاهر — وهذه هشاشة كانت قائمة في الشكل القديم.
    show: hasPermission(role, 'products') || hasPermission(role, 'reports_basic')
      || hasPermission(role, 'finance_limited') || role === -1,
    items: [
      { to: '/Cate2', icon: Package, label: 'المنتجات', show: hasPermission(role, 'products') },
      { to: '/deviceReports', icon: BarChart3, label: 'تقارير الأجهزة', show: hasPermission(role, 'reports_basic') || hasPermission(role, 'finance_limited') || role === -1 },
      { to: '/stockTransfer', icon: Archive, label: 'التحويل للمخزن', show: hasPermission(role, 'finance_limited') || role === -1 },
      { to: '/deviceLogs', icon: BarChart3, label: 'سجل الأجهزة والمسؤولية', show: hasPermission(role, 'reports_basic') || hasPermission(role, 'finance_limited') || role === -1 },
      { to: '/exchangeReturns', icon: Wrench, label: 'تحويل أجهزة إلى الصيانة', show: hasPermission(role, 'finance_limited') || role === -1 }
    ]
  },
  {
    id: 'finance',
    title: 'المالية',
    icon: DollarSign,
    color: 'green',
    show: hasPermission(role, 'finance_limited') || role === -1,
    items: [
      { to: '/safe', icon: DollarSign, label: 'الخزينة', show: role === -1 },
      { to: '/financeReport', icon: BarChart3, label: 'المطابقات — التقرير المالي', show: role === -1 },
      { to: '/Expenses', icon: TrendingDown, label: 'المصاريف', show: hasPermission(role, 'finance_limited') || role === -1 },
      { to: '/billsList', icon: ShoppingCart, label: 'المشتريات', show: hasPermission(role, 'finance_limited') || role === -1, badge: billsCount },
      { to: '/purchaseLists', icon: ShoppingCart, label: 'مشتريات الأجهزة', show: hasPermission(role, 'finance_limited') || role === -1 },
      { to: '/spareParts', icon: Package, label: 'قطع الغيار', show: hasPermission(role, 'finance_limited') || role === -1 },
      { to: '/suppliersList', icon: Store, label: 'التجار', show: hasPermission(role, 'finance_limited') || role === -1 }
    ]
  },
  {
    id: 'employees',
    title: 'الموظفين',
    icon: Users,
    color: 'purple',
    show: hasPermission(role, 'monitoring'),
    items: [
      { to: '/MenegeEmployee', icon: UserCog, label: 'إدارة موظفين الطلبات', show: hasPermission(role, 'monitoring') },
      { to: '/Employee', icon: UserCheck, label: 'تقارير موظفين الطلبات', show: hasPermission(role, 'monitoring') }
    ]
  },
  {
    id: 'monitoring',
    title: 'المتابعة',
    icon: Eye,
    color: 'yellow',
    // معطَّل حالياً بطلب المستخدم — الأصل: hasPermission(role, 'monitoring')
    show: false,  // ← بدّلها إلى hasPermission(role, 'monitoring') لإعادته
    items: [
      { to: '/newNotifications', icon: Bell, label: 'التبليغات الجديدة', show: hasPermission(role, 'monitoring') },
      { to: '/noResponse', icon: Clock, label: 'لا يرد', show: hasPermission(role, 'monitoring') },
      { to: '/postponed', icon: Clock, label: 'مؤجل', show: hasPermission(role, 'monitoring') }
    ]
  },
  {
    id: 'orders',
    title: 'الطلبات والشحن',
    icon: Truck,
    color: 'pink',
    show: hasPermission(role, 'orders'),
    items: [
      { to: '/unavailable', icon: PackageX, label: 'الغير موجود', show: hasPermission(role, 'orders') },
      { to: '/fromordersWatting', icon: FileText, label: 'قبل الطباعة', show: hasPermission(role, 'orders') },
      { to: '/print', icon: Printer, label: 'طباعة وصولات', show: hasPermission(role, 'orders') },
      { to: '/successLists', icon: CheckCheck, label: 'كشوفات الإنجاح', show: hasPermission(role, 'orders') },
      { to: '/printlist', icon: Archive, label: 'أرشيف الطباعة', show: hasPermission(role, 'orders') },
      { to: '/shippingcompaniesList', icon: Truck, label: 'شركات التوصيل', show: hasPermission(role, 'orders') },
      { to: '/replacement', icon: RotateCcw, label: 'الاستبدالات', show: hasPermission(role, 'orders') },
      { to: '/Search', icon: Search, label: 'بحث', show: hasPermission(role, 'orders') },
      { to: '/rejctedList', icon: ListX, label: 'قوائم الراجع', show: hasPermission(role, 'orders') }
    ]
  },
  {
    id: 'maintenance',
    title: 'الصيانة',
    icon: Wrench,
    color: 'orange',
    // معطَّل حالياً بطلب المستخدم — الأصل: hasPermission(role, 'maintenance')
    show: false,  // ← بدّلها إلى hasPermission(role, 'maintenance') لإعادته
    items: [
      { to: '/sanaLists', icon: Settings, label: 'تحويلات الصيانة', show: hasPermission(role, 'maintenance') },
      { to: '/sanaDevs', icon: Wrench, label: 'أجهزة تحت الصيانة', show: hasPermission(role, 'maintenance') },
      { to: '/sanaReport', icon: BarChart3, label: 'تقارير الصيانة', show: hasPermission(role, 'maintenance') }
    ]
  },
  {
    id: 'reports',
    title: 'التقارير',
    icon: BarChart3,
    color: 'cyan',
    show: hasPermission(role, 'reports_basic') || hasPermission(role, 'reports_promotion') || role === -1,
    items: [
      { to: '/calsslog', icon: Phone, label: 'سجل تأكيد الطلبات', show: hasPermission(role, 'reports_basic') || role === -1 },
      { to: '/logs', icon: PhoneOff, label: 'غير متصل بهم', show: hasPermission(role, 'reports_basic') || role === -1 },
      { to: '/OrdersStatusReports', icon: ClipboardList, label: 'تقارير حالات الطلبات', show: role === -1 },
      { to: '/ordersReports', icon: BarChart3, label: 'تقارير الطلبات', show: role === -1 },
      { to: '/wattingselles', icon: Calendar, label: 'تقارير الانتظار', show: role !== 2 },
      { to: '/check', icon: AlertTriangle, label: 'تقارير الغير مؤكد', show: role !== 2 },
      { to: '/miss', icon: CheckCircle, label: 'تقارير الايرد', show: role !== 2 },
      { to: '/selles', icon: TrendingUp, label: 'تقارير المبيعات', show: role !== 2 },
      { to: '/AutoCamp', icon: Megaphone, label: 'تقارير الترويج', show: hasPermission(role, 'reports_promotion') || role === -1 },
      { to: '/SettingDash', icon: BarChart3, label: 'الإعدادات والتقارير', show: hasPermission(role, 'reports_basic') || role === -1 }
    ]
  }
];

// ألوان الأقسام — تُستعمل للعمود الفقري ونقطة القسم فقط
const SECTION_COLOR = {
  blue: '#3b82f6', green: '#22c55e', purple: '#a855f7',
  cyan: '#06b6d4', orange: '#f97316', red: '#ef4444',
  yellow: '#eab308', pink: '#ec4899', indigo: '#6366f1',
};

// NavSection Component
const NavSection = ({ section, isExpanded, onToggle, onItemClick, currentPath, mini }) => {
  const visibleItems = section.items.filter(item => item.show);
  if (!section.show || visibleItems.length === 0) return null;

  const tint = SECTION_COLOR[section.color] || '#94a3b8';
  const hasActive = visibleItems.some(i => i.to === currentPath);
  // البحث يفتح كل ما تبقّى، والوضع المطويّ يعرض الأيقونات دائماً
  const open = mini || isExpanded;

  return (
    <div className={'sb-sec tinted' + (hasActive ? ' on' : '')} style={{ '--sec': tint }}>
      <button type="button" className={'sb-sec-btn' + (hasActive ? ' has-active' : '')}
        onClick={onToggle} aria-expanded={open ? 'true' : 'false'}>
        <span className="sb-sec-t">{section.title}</span>
        <span className="sb-sec-n">{visibleItems.length}</span>
        <span className="sb-sec-ico" style={{ background: tint }} />
        <ChevronLeft className={'sb-caret' + (open ? ' open' : '')} size={16} />
      </button>

      <div className={'sb-items' + (open ? ' open' : '')}>
        {visibleItems.map((item, index) => {
          const ItemIcon = item.icon;
          const isActive = currentPath === item.to;
          return (
            <NavLink key={index} to={item.to} onClick={onItemClick}
              title={mini ? item.label : null}
              className={'sb-link' + (isActive ? ' active' : '')}>
              {/* الترتيب في DOM هو ما يحدّد الموضع مع direction:rtl —
                  الاسم أولاً فيقع يميناً، والأيقونة آخراً فتقع يساراً. */}
              <span className="sb-link-t">{item.label}</span>
              {item.badge > 0 ? <span className="sb-badge">{item.badge}</span> : null}
              <ItemIcon className="sb-link-ico" size={18} />
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

// DrawerContent Component
const DrawerContent = ({ currentPath, onItemClick, billsCount, mini, dark, fs, onToggleTheme, onToggleMini, onFs, showMiniToggle }) => {
  const sections = getNavigationSections(role, billsCount);
  const [query, setQuery] = React.useState('');

  // الأقسام مفتوحة، إلا أن قسم الصفحة الحالية يبقى مفتوحاً دائماً
  const [collapsed, setCollapsed] = React.useState({});
  const toggleSection = (id) => setCollapsed(p => Object.assign({}, p, { [id]: !p[id] }));

  const q = query.trim();
  const filtered = !q ? sections : sections.map(sec => Object.assign({}, sec, {
    items: sec.items.filter(it => it.label.indexOf(q) > -1),
  })).filter(sec => sec.items.filter(i => i.show).length > 0);

  const handleLogout = () => {
    cookies.remove("token");
    window.location.href = '/';
  };

  const initial = userName ? userName.charAt(0).toUpperCase() : 'م';
  const nothing = q && filtered.length === 0;

  return (
    <div className={'sb fs-' + fs + (mini ? ' mini' : '') + (dark ? ' dark' : '')}>
      {/* بطاقة المستخدم صارت أول ما يُرى — حُذفت كتلة «لوحة التحكم /
          نظام إدارة الأجهزة» بطلب المستخدم، واسم الصفحة يظهر في
          الشريط العلوي فلا تضيع الهوية. */}
      <div className="sb-user">
        <div className="sb-ava">{initial}</div>
        <div className="sb-user-t">
          <h4>{userName || 'المستخدم'}</h4>
          <div><span className="sb-dot" />متصل الآن</div>
        </div>
      </div>

      <div className="sb-head">
        <div className="sb-tools">
          <button type="button" className="sb-icon" onClick={onToggleTheme}
            title={dark ? 'الوضع الفاتح' : 'الوضع الداكن'} aria-label="تبديل الوضع">
            {!mini ? <span>{dark ? 'فاتح' : 'داكن'}</span> : null}
            {dark ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          {showMiniToggle ? (
            <button type="button" className="sb-icon" onClick={onToggleMini}
              title={mini ? 'توسيع القائمة' : 'طيّ القائمة'} aria-label="طيّ القائمة">
              {!mini ? <span>طيّ</span> : null}
              {mini ? <ChevronsLeft size={16} /> : <ChevronsRight size={16} />}
            </button>
          ) : null}
        </div>

        <div className="sb-fs">
          <span className="sb-fs-l">حجم الخط</span>
          <button type="button" className={'s' + (fs === 's' ? ' on' : '')} onClick={() => onFs('s')} title="صغير" aria-label="خط صغير">أ</button>
          <button type="button" className={'m' + (fs === 'm' ? ' on' : '')} onClick={() => onFs('m')} title="متوسط" aria-label="خط متوسط">أ</button>
          <button type="button" className={'g' + (fs === 'l' ? ' on' : '')} onClick={() => onFs('l')} title="كبير" aria-label="خط كبير">أ</button>
        </div>

        <div className="sb-search">
          <Search size={15} />
          <input value={query} onChange={e => setQuery(e.target.value)}
            placeholder="ابحث في القائمة…" aria-label="بحث في القائمة" />
        </div>
      </div>

      <nav className="sb-nav">
        {nothing ? <div className="sb-none">ما في نتيجة لـ «{q}»</div> : null}
        {filtered.map((section) => (
          <NavSection
            key={section.id}
            section={section}
            // البحث يفتح كل الأقسام، وقسم الصفحة الحالية لا ينطوي
            isExpanded={!!q || !collapsed[section.id]}
            onToggle={() => toggleSection(section.id)}
            onItemClick={onItemClick}
            currentPath={currentPath}
            mini={mini}
          />
        ))}
      </nav>

      <div className="sb-foot">
        <button type="button" className="sb-out" onClick={handleLogout}>
          <span>تسجيل الخروج</span><LogOut size={18} />
        </button>
      </div>
    </div>
  );
};

// عنوان الصفحة الحالية — يظهر في الشريط العلوي بدل ترحيب ثابت
const pageTitle = (path) => {
  const secs = getNavigationSections(role, 0);
  for (let i = 0; i < secs.length; i++) {
    const hit = secs[i].items.filter(x => x.to === path)[0];
    if (hit) return hit.label;
  }
  return 'لوحة التحكم';
};

// Main Component
function ResponsiveDrawer(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [mini, setMini] = React.useState(readPref(COLLAPSE_KEY, '0') === '1');
  const [dark, setDark] = React.useState(readPref(THEME_KEY, 'light') === 'dark');
  const [billsCount, setBillsCount] = React.useState(Number(localStorage.getItem('bills')) || 0);
  const [fs, setFs] = React.useState(readPref(FONT_KEY, 'm'));

  const classes = useStyles({ w: mini ? RAIL_MINI : RAIL_FULL });
  const currentPath = (props.match && props.match.path) || '';
  const authed = !!cookies.get("token");

  // 🐛 كان نداء الملف الشخصي يُطلق في جسم المكوّن، فيتكرّر مع كل
  // إعادة رسم (فتح قسم، طيّ الشريط…) وأي فشل يطرد المستخدم للصفحة
  // الرئيسية. صار مرة واحدة عند التركيب، ونتيجته في حالة React كي
  // يتحدّث شارة الفواتير فعلاً — كان متغيّراً عاماً لا يعيد الرسم.
  React.useEffect(() => { ensureFont(); }, []);

  React.useEffect(() => {
    if (!authed) return;
    let alive = true;
    axios.get(host + 'dashbord/profile/', {
      headers: { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") },
    })
      .then(res => {
        if (!alive) return;
        const n = res && res.data && res.data.data ? res.data.data.billsCount : 0;
        setBillsCount(n);
        localStorage.setItem("bills", n);
      })
      .catch(() => { window.location.href = "/"; });
    return () => { alive = false; };
  }, [authed]);

  const toggleTheme = () => {
    setDark(d => { writePref(THEME_KEY, !d ? 'dark' : 'light'); return !d; });
  };
  const changeFs = (v) => { writePref(FONT_KEY, v); setFs(v); };
  const toggleMini = () => {
    setMini(m => { writePref(COLLAPSE_KEY, !m ? '1' : '0'); return !m; });
  };

  if (!authed) return <Login />;

  const drawerBody = (isMini, onItem, showMiniToggle) => (
    <DrawerContent
      currentPath={currentPath}
      onItemClick={onItem}
      billsCount={billsCount}
      mini={isMini}
      dark={dark}
      fs={fs}
      onToggleTheme={toggleTheme}
      onToggleMini={toggleMini}
      onFs={changeFs}
      showMiniToggle={showMiniToggle}
    />
  );

  return (
    <div className={classes.root} dir="rtl">
      <style dangerouslySetInnerHTML={{ __html: sidebarStyles }} />

      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton color="inherit" aria-label="فتح القائمة" edge="start"
            onClick={() => setMobileOpen(true)} className={classes.menuButton}>
            <Menu size={22} />
          </IconButton>
          <Typography noWrap className="sb-title">{pageTitle(currentPath)}</Typography>
          <span style={{ flex: 1 }} />
          <span className="sb-who">{userName || ''}</span>
        </Toolbar>
      </AppBar>

      <nav className={classes.drawer}>
        {/* موبايل/تابلت — مؤقّت، ويُغلق عند اختيار صفحة */}
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            classes={{ paper: classes.drawerPaperMobile }}
            ModalProps={{ keepMounted: true }}
          >
            {drawerBody(false, () => setMobileOpen(false), false)}
          </Drawer>
        </Hidden>

        {/* سطح المكتب — دائم، قابل للطيّ */}
        <Hidden smDown implementation="css">
          <Drawer classes={{ paper: classes.drawerPaper }} variant="permanent" anchor="right" open>
            {drawerBody(mini, () => { }, true)}
          </Drawer>
        </Hidden>
      </nav>

      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={'dash-card fs-' + fs}>
          {renderPage(props)}
        </div>
      </main>
    </div>
  );
}

// Page Rendering
const renderPage = (props) => {
  const routeComponents = {
    '/Cate2': Cate2,
    '/safe': Safe,
    '/sanaReport': SanaReport,
    '/uncheckedBill': UncheckedBill,
    '/sanaDevs': SanaDevs,
    '/Order2Dash': Order2,
    '/doneselles': DoneReports,
    '/billsList': BillsList,
    '/suppliersList': SuppliersList,
    '/purchaseLists': PurchaseLists,
    '/purchaseList': PurchaseListView,
    '/spareParts': SpareParts,
    '/stockTransfer': StockTransfer,
    '/deviceLogs': DeviceLogs,
    '/exchangeReturns': ExchangeReturns,
    '/wattingselles': Wattingselles,
    '/printlist': Print_list,
    '/miss': Miss,
    '/SettingDash': Setting,
    '/Expenses': Expenses,
    '/EmployeeList': UsersList,
    '/MenegeEmployee': UsersList,
    '/Employee': UsersList,
    '/shippingcompaniesList': ShippingcompaniesList,
    '/unavailable': Unavailable,
    '/sanaLists': SanaLists,
    '/delevryReports': DelveryReports,
    '/fromorders': FromOrders,
    '/sanaToInv': SanaToInv,
    '/fromordersWatting': FromOrdersWatting,
    '/selles': Sells,
    '/apadningOrders': Apanding_order,
    '/cancelledOrders': CancelledOrders,
    '/logs': Logs,
    '/logscan': LogsCan,
    '/Search': SearchPage,
    '/DoneOrder': DoneOrder,
    '/RejectOrder': RejectOrder,
    '/calledOrders': CalledOrders,
    '/DoneTable': DoneTable,
    '/sheet': Sheet,
    '/check': Check,
    '/AutoCamp': AdsReprots,
    '/print': Print,
    '/calsslog': Calsslog,
    '/m3alk': M3alk,
    '/rejctedList': RejctedList,
    '/replacement': Replacement,
    '/newNotifications': NewNotifications,
    '/noResponse': noResponse,
    '/postponed': Postponed,
    '/OrdersStatusReports': OrdersStatusReports,
    '/ordersReports': OrdersReports,
    '/deviceReports': DeviceReports,
    '/financeReport': FinanceReport,
  };

  const Component = routeComponents[props.match.path];
  return Component ? <Component /> : null;
};


ResponsiveDrawer.propTypes = {
  container: PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element),
};

export default ResponsiveDrawer;
